import { render } from "./SearchComp.vue?vue&type=template&id=4cfbcd9a"
import script from "./SearchComp.vue?vue&type=script&lang=js"
export * from "./SearchComp.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__